var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgent2K(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "translate(-6.272916,-617.65563)",
    id: "layer1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 14.690124,618.8826 c -1.303811,-0.0599 -2.322953,1.34632 -2.065752,2.57909 0.02331,5.80177 -0.04897,11.60393 0.0371,17.40541 0.223605,1.18251 1.551712,1.86234 2.678412,1.63391 2.178834,-0.0408 4.36968,0.10447 6.540425,-0.0849 1.100112,-0.33223 1.639817,-1.60102 1.438512,-2.67436 -0.0216,-5.74064 0.04877,-11.48166 -0.03651,-17.222 -0.208908,-1.08734 -1.392854,-1.81989 -2.463213,-1.6371 -2.042977,-6e-5 -4.08606,10e-5 -6.128971,-8e-5 z m 2.248687,8.74456 c 0.688696,0 1.377393,0 2.066089,0 0,0.6887 0,1.37739 0,2.06609 -0.688696,0 -1.377393,0 -2.066089,0 0,-0.6887 0,-1.37739 0,-2.06609 z m 0,3.61565 c 0.688696,0 1.377393,0 2.066089,0 0,0.6887 0,1.37739 0,2.06609 -0.688696,0 -1.377393,0 -2.066089,0 0,-0.6887 0,-1.37739 0,-2.06609 z m 0,3.61566 c 0.688696,0 1.377393,0 2.066089,0 0,0.6887 0,1.37739 0,2.06609 -0.688696,0 -1.377393,0 -2.066089,0 0,-0.6887 0,-1.37739 0,-2.06609 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent2K);
export default __webpack_public_path__ + "static/media/agent2k.9cd84e235e39f82a0f21c012a87f922c.svg";
export { ForwardRef as ReactComponent };